<template>
  <canvas
    id="canvas"
    ref="canvas"
    :width="1180 * multiple"
    :height="600 * multiple"
  ></canvas>
</template>

<script>
export default {
  name: 'TrendCanvas',
  props: {
    multiple: {
      type: Number,
      default: 2
    },
    xList: {
      type: Array,
      default: () => []
    },
    yList: {
      type: Array,
      default: () => []
    },
    slice: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    areaColor: {
      type: Array,
      default: () => []
    },
    imgType: {
      type: [Number, String],
      default: () => 1
    }
  },
  data() {
    return {
      a: 0,
      b: 0
    }
  },
  watch: {
    data() {
      this.clearDraw()
      this.draw()
    }
  },
  mounted() {
    if (this.slice.length !== this.areaColor.length - 1) {
      console.warn('slice 跟 areaColor 區分的區塊跟所屬顏色要對應')
    }
    this.slice.forEach((val) => {
      this.yList.splice(val, 0, 'X')
    })
    this.drawImage()
    this.draw()
  },
  methods: {
    drawImage() {
      const ctx = this.$refs.canvas.getContext('2d')
      // 左邊的圖片
      const imgObj = new Image()
      const sizeheight = ((this.slice.length + 12) * 35 + 20) * this.multiple
      const sizewidth = 50 * this.multiple
      // // imgObj.src = `https://fakeimg.pl/${sizewidth}x${sizeheight}/`
      imgObj.src = require(`@/assets/style/desktop/img/table-img-${this.imgType}.png`)
      imgObj.onload = function() {
        ctx.drawImage(this, sizewidth, 0, sizewidth, sizeheight) // this即是imgObj
      }
    },
    draw() {
      const ctx = this.$refs.canvas.getContext('2d')

      // 設置參數 座標起始點, 單位寬度跟高度
      const startX = 140 * this.multiple
      const startY = 20 * this.multiple
      const xWidth = 33 * this.multiple
      const yWidth = 35 * this.multiple
      const multiple = this.multiple

      // X轴的标题
      ctx.font = `${16 * multiple}px Microsoft YaHei`
      ctx.fillStyle = '#000000'
      ctx.fillText(
        '期号',
        580 * multiple,
        startY + 40 * multiple + this.yList.length * yWidth
      )

      // X軸 刻度文字
      ctx.font = `${12 * multiple}px PingFang TC`
      ctx.fillStyle = '#000000'
      this.xList.forEach((name, index) => {
        ctx.fillText(
          name,
          startX + index * xWidth + 4,
          startY + this.yList.length * yWidth
        )
      })

      // Y軸 刻度文字
      ctx.font = `${16 * multiple}px Microsoft YaHei `
      ctx.fillStyle = '#000000'
      ctx.strokeStyle = '#000000'
      ctx.lineWidth = 1 * multiple
      this.yList.forEach((name, index) => {
        // 遇到 slice 就劃一條分隔線
        if (this.slice.includes(index)) {
          ctx.beginPath()
          ctx.moveTo(115 * multiple, startY + index * yWidth)
          ctx.lineTo(1150 * multiple, startY + index * yWidth)
          ctx.stroke()
          ctx.closePath()
        } else {
          ctx.fillText(
            this.chineseFormat(name),
            115 * multiple,
            startY + 8 + index * yWidth
          )
        }
      })

      // Y軸 欄位分隔線
      ctx.strokeStyle = '#CECCCC'
      ctx.lineWidth = 1 * multiple
      ctx.beginPath()
      this.yList.forEach((name, index) => {
        if (!this.slice.includes(index)) {
          ctx.moveTo(startX, startY + index * yWidth)
          ctx.lineTo(1150 * multiple, startY + index * yWidth)
        }
      })
      ctx.stroke()
      ctx.closePath()

      // 畫線2.0
      // this.data.forEach((ball, index) => {
      //   if (index > 0) {
      //     // const start = [
      //     //   startX + (15 * multiple) + (index - 1) * xWidth,
      //     //   startY + this.yList.indexOf(this.data[index - 1]) * yWidth
      //     // ]

      //     // const end = [
      //     //   startX + (15 * multiple) + index * xWidth,
      //     //   startY + this.yList.indexOf(ball) * yWidth
      //     // ]

      //     ctx.beginPath()
      //     // ctx.moveTo(start[0], start[1])

      //     this.line()

      //     // ctx.lineTo(end[0], end[1])

      //     ctx.stroke()
      //     ctx.closePath()
      //   }
      // })

      // 畫線
      this.data.forEach((ball, index) => {
        if (index > 0) {
          ctx.beginPath()
          ctx.moveTo(
            startX + 15 * multiple + (index - 1) * xWidth,
            startY + this.yList.indexOf(this.data[index - 1]) * yWidth
          )
          ctx.lineTo(
            startX + 15 * multiple + index * xWidth,
            startY + this.yList.indexOf(ball) * yWidth
          )
          ctx.stroke()
          ctx.closePath()
        }
      })

      // 畫點
      this.data.forEach((ball, index) => {
        ctx.fillStyle = this.areaColor[0]
        ctx.beginPath()
        this.slice.forEach((val, index) => {
          if (this.yList.indexOf(ball) > val) {
            ctx.fillStyle = this.areaColor[index + 1]
          }
        })
        ctx.arc(
          startX + 15 * multiple + index * xWidth,
          startY + this.yList.indexOf(ball) * yWidth,
          6 * multiple,
          0,
          2 * Math.PI
        ) // 圓跟期數對齊
        ctx.fill()
        ctx.closePath()
      })
    },
    clearDraw() {
      const ctx = this.$refs.canvas.getContext('2d')
      const multiple = this.multiple
      ctx.clearRect(100 * multiple, 0, 1180 * multiple, 580 * multiple)
    },
    chineseFormat(val) {
      switch (val) {
        case 'shengXiao_gou':
          return '狗'
        case 'shengXiao_hou':
          return '猴'
        case 'shengXiao_hu':
          return '虎'
        case 'shengXiao_jhu':
          return '猪'
        case 'shengXiao_ji':
          return '鸡'
        case 'shengXiao_long':
          return '龙'
        case 'shengXiao_ma':
          return '马'
        case 'shengXiao_niou':
          return '牛'
        case 'shengXiao_she':
          return '蛇'
        case 'shengXiao_shu':
          return '鼠'
        case 'shengXiao_tu':
          return '兔'
        case 'shengXiao_yang':
          return '羊'
      }
    },
    // 一階貝茲
    oneBezier(t, p1, p2) {
      const [x1, y1] = p1
      const [x2, y2] = p2
      const x = x1 + (x2 - x1) * t
      const y = y1 + (y2 - y1) * t
      return [x, y]
    }
    // 畫線2.0 測試中
    // line() {
    //   const ctx = this.$refs.canvas.getContext('2d')
    //   ctx.clearRect(0, 0, 0, 0)
    //   ctx.beginPath()
    //   if (this.a < 1) {
    //     ctx.moveTo(0, 100)
    //     ctx.lineTo(this.a * 10 * 0.00001, 100)
    //     ctx.stroke()
    //     ctx.closePath()
    //     this.a += 0.1
    //     window.requestAnimationFrame(this.line)
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
#canvas {
  width: 100%;
}
</style>
